module.exports = __webpack_public_path__ + "img/armhole front.4b388e1a.png";